import {
  AfterViewChecked,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { HttpHeaders } from '@angular/common/http';
import { TourService } from 'src/app/api/tourism/tour.service';
import { ToolsService } from 'src/app/utils/tools.service';
import Sortable from 'sortablejs';
import { ImageCroppedEvent } from 'ngx-image-cropper';
declare var $: any;

@Component({
  selector: 'app-tour-gallery-img',
  templateUrl: './tour-gallery-img.component.html',
  styleUrls: ['./tour-gallery-img.component.css']
})
export class TourGalleryImgComponent implements OnInit, AfterViewChecked {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('sortableContainer') sortableContainer!: ElementRef;

  branchofficeSlug: string = '';
  nameMenu: string = 'gallery_image';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  numberMaxImg: number = environment.max_number_img;

  imageUrl: any = null;
  fileUrlImage: any = null;

  filesToUpload: any = [];
  photosOld: any = [];

  // cropped portada
  imageCoverChangedEvent: string = '';
  currentCoverCroppedImage: string = '';

  // cambios para ng-cropper
  isCropping: boolean = false;
  currentIndex: number = 0;
  imageChangedEvent: any = '';
  fileQueue: File[] = [];
  croppedImages: string[] = [];
  currentCroppedImage: string = '';

  // sortable
  sortableInstanciado = false;
  sortableInstance: any;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2,
    private globalService: GlobalService,
    private tourService: TourService,
    private navigationTrackerService: NavigationTrackerService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.item = this.fb.group({
      description: [''],
      url_image: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    this.showloaderLogin();
    if (this.isEdit) {
      this.editData();
    }
  }

  ngAfterViewChecked(): void {
    if (
      this.photosOld.length > 0 &&
      this.sortableContainer &&
      !this.sortableInstanciado
    ) {
      this.sortableInstanciado = true;
      // Destruir instancia previa si existe
      if (this.sortableInstance) {
        this.sortableInstance.destroy();
      }

      this.sortableInstance = Sortable.create(
        this.sortableContainer.nativeElement,
        {
          animation: 150,
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          fallbackClass: 'sortable-fallback',
          forceFallback: true, // fuerza el uso del clon, mejora consistencia visual
          onEnd: (event: any) => {
            const movedItem = this.photosOld.splice(event.oldIndex, 1)[0];
            this.photosOld.splice(event.newIndex, 0, movedItem);
            this.photosOld.forEach((img: any, idx: any) => {
              img.position = idx + 1;
            });
          }
        }
      );
    }
  }

  trackById(index: number, item: any): number {
    return item.id;
  }

  editData() {
    this.tourService.get(this.checkId).subscribe({
      next: (data: any) => {
        // 🔁 Reseteo de campos después del envío
        this.fileQueue = [];
        this.croppedImages = [];
        this.currentCroppedImage = '';
        this.imageChangedEvent = '';
        this.currentIndex = 0;
        this.filesToUpload = [];
        if (this.fileInput) {
          this.fileInput.nativeElement.value = '';
        }
        // ========

        let _item = data.data;
        this.item.patchValue({
          tradename: _item.tradename,
          url_image: _item.url_image
        });
        this.photosOld = _item.gallery_image_str;
        this.photosOld = this.photosOld
          .sort((a: any, b: any) => {
            if (a.position == null && b.position == null) return 0;
            if (a.position == null) return 1;
            if (b.position == null) return -1;
            return a.position - b.position;
          })
          .map((img: any, index: any) => {
            // Asegurarse de que todos tengan un position asignado en memoria
            img.position = index + 1;
            return img;
          });

        this.sortableInstanciado = false; // 🧠 Habilita reinicio de Sortable
        this.hideloaderLogin();
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  // cambios para ng-cropper portada ********************
  onFileSelectedShowCrop(event: any): void {
    const file = event.target.files[0];
    this.imageCoverChangedEvent = event; // Se pasa al image-cropper
    $('#modalCroppedCover').modal('show');
  }

  imageCroppedCover(event: ImageCroppedEvent): void {
    if (event.base64) {
      this.currentCoverCroppedImage = event.base64;
      this.fileUrlImage = this.base64ToFileCover(
        event.base64,
        'recortada.jpg' // o .png según tu formato
      );
    }
  }

  confirmCrop(): void {
    this.imageUrl = this.currentCoverCroppedImage;
    this.item.patchValue({
      url_image: null
    });

    // Opcional: convertir base64 a archivo si necesitas subirlo luego
    this.fileUrlImage = this.base64ToFileCover(
      this.currentCoverCroppedImage,
      'cropped.png'
    );

    $('#modalCroppedCover').modal('hide');
  }

  base64ToFileCover(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  // cambios para galeria de imagenes ==============**
  imageCropped(event: ImageCroppedEvent): void {
    if (event.base64) {
      this.currentCroppedImage = event.base64;
    }
  }

  fileChangeEvent(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileQueue = Array.from(input.files);
      this.currentIndex = 0;
      this.croppedImages = [];
      this.filesToUpload = [];
      this.loadImageAtCurrentIndex();
      this.hideloaderLogin();
    }
  }

  loadImageAtCurrentIndex(): void {
    if (this.currentIndex < this.croppedImages.length) {
      // Ya hay una imagen recortada para esta posición, la mostramos
      this.currentCroppedImage = this.croppedImages[this.currentIndex];

      // También cargamos el archivo original para permitir recorte (opcional)
      const originalFile = this.fileQueue[this.currentIndex];
      this.processFile(originalFile);
    } else {
      // No hay imagen recortada, solo cargamos la original para recortar
      const file = this.fileQueue[this.currentIndex];
      this.processFile(file);
      this.currentCroppedImage = '';
    }
  }

  goToPrevious(): void {
    if (this.currentIndex > 0) {
      // Retrocedemos el índice
      this.currentIndex--;

      // Como vamos atrás, eliminamos la última imagen y archivo que se guardó,
      // porque el usuario volverá a editar esa imagen
      this.croppedImages.pop();
      this.filesToUpload.pop();

      // Cargamos la imagen (original o recortada)
      this.loadImageAtCurrentIndex();
    }
  }

  removeImage(index: number): void {
    this.croppedImages.splice(index, 1);
    this.filesToUpload.splice(index, 1);

    // Si eliminamos la imagen que está siendo recortada actualmente
    if (index === this.currentIndex) {
      // Si hay más imágenes por recortar, cargar la siguiente
      if (this.currentIndex < this.fileQueue.length - 1) {
        this.loadImageAtCurrentIndex();
      } else {
        // No hay más imágenes que recortar
        this.imageChangedEvent = '';
        this.currentCroppedImage = '';
      }
    }

    // Ajustar índice si eliminamos una imagen anterior
    if (this.currentIndex > index) {
      this.currentIndex--;
    }
  }

  skipCurrent(): void {
    // Avanza sin guardar imagen actual
    if (this.currentIndex < this.fileQueue.length - 1) {
      this.currentIndex++;
      this.loadImageAtCurrentIndex();
    } else {
      this.imageChangedEvent = '';
      this.currentCroppedImage = '';
    }
  }

  cropAndNext(): void {
    this.isCropping = true;
    setTimeout(() => {
      if (this.currentCroppedImage) {
        // Guardamos imagen recortada en la posición actual
        if (this.currentIndex < this.croppedImages.length) {
          this.croppedImages[this.currentIndex] = this.currentCroppedImage;
          this.filesToUpload[this.currentIndex] = this.base64ToFile(
            this.currentCroppedImage,
            `image_${this.currentIndex + 1}.png`
          );
        } else {
          this.croppedImages.push(this.currentCroppedImage);
          const file = this.base64ToFile(
            this.currentCroppedImage,
            `image_${this.croppedImages.length}.png`
          );
          this.filesToUpload.push(file);
        }

        // Avanzamos a la siguiente imagen si hay
        if (this.currentIndex < this.fileQueue.length - 1) {
          this.currentIndex++;
          this.loadImageAtCurrentIndex();
        } else {
          // No hay más imágenes, limpiar o mostrar mensaje si quieres
          this.imageChangedEvent = '';
          this.currentCroppedImage = '';
        }
      }
      this.isCropping = false;
    }, 500);
  }

  base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  processFile(file: File): void {
    const fileInput = new DataTransfer();
    fileInput.items.add(file);

    const event = ({
      target: {
        files: fileInput.files
      }
    } as unknown) as Event;

    // Esta asignación si esperas imageChangedEvent como tipo InputEvent
    this.imageChangedEvent = event;
    this.currentCroppedImage = '';
  }

  // end galeria imagenes ==============*****

  // cambios para ng-cropper
  // imageCropped(event: ImageCroppedEvent): void {
  //   if (event.base64) {
  //     this.currentCroppedImage = event.base64;
  //   }
  // }

  // fileChangeEvent(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files.length > 0) {
  //     this.fileQueue = Array.from(input.files);
  //     this.currentIndex = 0;
  //     this.croppedImages = [];
  //     this.filesToUpload = [];
  //     this.loadImageAtCurrentIndex();
  //   }
  // }

  // loadImageAtCurrentIndex(): void {
  //   if (this.currentIndex < this.croppedImages.length) {
  //     // Ya hay una imagen recortada para esta posición, la mostramos
  //     this.currentCroppedImage = this.croppedImages[this.currentIndex];

  //     // También cargamos el archivo original para permitir recorte (opcional)
  //     const originalFile = this.fileQueue[this.currentIndex];
  //     this.processFile(originalFile);
  //   } else {
  //     // No hay imagen recortada, solo cargamos la original para recortar
  //     const file = this.fileQueue[this.currentIndex];
  //     this.processFile(file);
  //     this.currentCroppedImage = '';
  //   }
  // }

  // goToPrevious(): void {
  //   if (this.currentIndex > 0) {
  //     // Retrocedemos el índice
  //     this.currentIndex--;

  //     // Como vamos atrás, eliminamos la última imagen y archivo que se guardó,
  //     // porque el usuario volverá a editar esa imagen
  //     this.croppedImages.pop();
  //     this.filesToUpload.pop();

  //     // Cargamos la imagen (original o recortada)
  //     this.loadImageAtCurrentIndex();
  //   }
  // }

  // cropAndNext(): void {
  //   this.isCropping = true;
  //   setTimeout(() => {
  //     if (this.currentCroppedImage) {
  //       // Guardamos imagen recortada en la posición actual
  //       if (this.currentIndex < this.croppedImages.length) {
  //         this.croppedImages[this.currentIndex] = this.currentCroppedImage;
  //         this.filesToUpload[this.currentIndex] = this.base64ToFile(
  //           this.currentCroppedImage,
  //           `image_${this.currentIndex + 1}.png`
  //         );
  //       } else {
  //         this.croppedImages.push(this.currentCroppedImage);
  //         const file = this.base64ToFile(
  //           this.currentCroppedImage,
  //           `image_${this.croppedImages.length}.png`
  //         );
  //         this.filesToUpload.push(file);
  //       }

  //       // Avanzamos a la siguiente imagen si hay
  //       if (this.currentIndex < this.fileQueue.length - 1) {
  //         this.currentIndex++;
  //         this.loadImageAtCurrentIndex();
  //       } else {
  //         // No hay más imágenes, limpiar o mostrar mensaje si quieres
  //         this.imageChangedEvent = '';
  //         this.currentCroppedImage = '';
  //       }
  //     }
  //     this.isCropping = false;
  //   }, 500);
  // }

  // processFile(file: File): void {
  //   const fileInput = new DataTransfer();
  //   fileInput.items.add(file);

  //   const event = ({
  //     target: {
  //       files: fileInput.files
  //     }
  //   } as unknown) as Event;

  //   // Esta asignación si esperas imageChangedEvent como tipo InputEvent
  //   this.imageChangedEvent = event;
  //   this.currentCroppedImage = '';
  // }

  // base64ToFile(base64: string, filename: string): File {
  //   const arr = base64.split(',');
  //   const mime = arr[0].match(/:(.*?);/)![1];
  //   const bstr = atob(arr[1]);
  //   let n = bstr.length;
  //   const u8arr = new Uint8Array(n);

  //   while (n--) {
  //     u8arr[n] = bstr.charCodeAt(n);
  //   }

  //   return new File([u8arr], filename, { type: mime });
  // }

  // end cropper =============================

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
      this.previewImage(file);
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result as string;
      this.item.patchValue({
        url_image: null
      });
    };
    reader.readAsDataURL(file);
  }

  onFileSelectedMult(event: any): void {
    // Reset the files array on each selection
    this.filesToUpload = [];

    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (this.toolsService.validateSizeImg(file, true)) {
        // Add file to the array
        this.filesToUpload.push(file);
        // Generate image preview
        this.generateImagePreview(file);
      }
    }
  }

  generateImagePreview(file: any): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      file['previewUrl'] = e.target.result;
      file['tag'] = '';
      file['position'] = '';
    };
    reader.readAsDataURL(file);
  }

  changePositionImage(param: any, index: number): void {
    this.filesToUpload[index].position = param.value;
  }

  changeTagImage(param: any, index: number): void {
    this.filesToUpload[index].tag = param.value;
  }

  // removeImage(index: any) {
  //   this.filesToUpload.splice(index, 1);
  // }

  changeTagImageOld(param: any, index: number): void {
    this.photosOld[index].tag = param.value;
  }

  changePositionImageOld(param: any, index: number): void {
    this.photosOld[index].position = param.value;
  }

  removeImageOld(index: any) {
    this.photosOld.splice(index, 1);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    if (this.validate()) {
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      formData.append('id', this.checkId.toString());
      formData.append('url_image', this.fileUrlImage);

      const _files = [];

      if (this.filesToUpload.length > 0) {
        for (let i = 0; i < this.filesToUpload.length; i++) {
          formData.append('images[]', this.filesToUpload[i]);
          let _obj = {
            index: i,
            tag: this.filesToUpload[i].tag,
            position: this.filesToUpload[i].position
          };
          _files.push(_obj);
        }
      } else {
        formData.append('images', '0');
      }

      formData.append('photosold', JSON.stringify(this.photosOld));
      formData.append('files', JSON.stringify(_files));

      this.tourService.saveImage(formData).subscribe({
        next: (data: any) => {
          this.showloaderLogin();
          this.alertifyMsg.success('Registro actualizado con éxito');
          this.filesToUpload = [];
          this.photosOld = [];
          this.editData();
        }
      });
    }
  }

  validate() {
    let total_img_ = environment.max_number_img;
    let sum_ = this.photosOld.length + this.filesToUpload.length;
    if (sum_ > total_img_) {
      this.alertifyMsg.warning(
        'Solo puede registrar un máximo de ' + total_img_ + ' imágenes'
      );
      return false;
    }

    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/turismo/tours/lista']);
  }

  refresh() {
    this.showloaderLogin();
    this.filesToUpload = [];
    this.editData();
  }

  showloaderLogin() {
    (<HTMLInputElement>(
      document.getElementById('box-loading-gallery')
    )).style.display = 'block';
  }

  hideloaderLogin() {
    (<HTMLInputElement>(
      document.getElementById('box-loading-gallery')
    )).style.display = 'none';
  }
}
